/* ═══════════════════════════════════════════
   MARELLE — Theme JS global
   Reveal al scroll + header sólido.
   Cargar en layout/theme.liquid antes de </body>
═══════════════════════════════════════════ */

(function () {
  // ── Reveal al scroll ──
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: .12, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.m-reveal').forEach(el => revealObs.observe(el));

  // ── Header sólido al scroll ──
  const header = document.getElementById('marelle-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-solid', window.scrollY > 60);
    }, { passive: true });
  }

  // ── Menú móvil (desplegable bajo el header) ──
  const menuToggle = document.querySelector('#marelle-header .menu-toggle');
  if (header && menuToggle) {
    menuToggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('menu-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }
})();
